import React from 'react';
import styled from 'styled-components';

const Timestamp = ({ date }) => <Wrapper>{date.format('DD.MM.YYYY')}</Wrapper>;

const Wrapper = styled.div``;

export default Timestamp;
